<template>
  <div class="page-col animated fadeIn">
    <div class="page-main">
      <!-- Header Premium -->
      <HeaderPadrao 
        :icon="isEdit ? 'fa fa-edit' : 'fa fa-plus-circle'" 
        :titulo="isEdit ? 'Editar Layout' : 'Novo Layout'"
        class="mb-3"
      >
        <template #subtitulo>
          Configuração do mapeamento de campos para importação
        </template>

        <template #acoes>
            <b-button variant="light" pill class="px-4 font-weight-bold shadow-sm" @click="voltar()">
                <i class="fa fa-arrow-left mr-2"></i> Voltar
            </b-button>
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm ml-2" @click="salvar()">
                <i class="fa fa-save mr-2"></i> SALVAR LAYOUT
            </b-button>
        </template>
      </HeaderPadrao>

      <b-row class="px-3">
        <!-- Master Section -->
        <b-col lg="12" class="mb-4">
            <b-card class="border-0 shadow-sm rounded-lg">
                <template #header>
                    <div class="d-flex align-items-center">
                        <i class="fa fa-info-circle text-primary mr-2"></i>
                        <h6 class="mb-0 font-weight-bold">Dados do Cabeçalho</h6>
                    </div>
                </template>
                <b-row>
                    <b-col md="6">
                        <b-form-group label="Descrição do Layout" label-class="modal-label-premium">
                            <b-form-input 
                                v-model="layout.DESCRICAO" 
                                placeholder="Ex: Importação XML Fornecedor X" 
                                class="rounded-pill bg-white border shadow-xs px-3"
                                :state="valDescricao"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <cliente-pesquisa 
                            @retornaId="layout.FORNECEDOR_ID = $event"
                            :idInicial="layout.FORNECEDOR_ID"
                            label="Fornecedor (Obrigatório)"
                            place="Selecione o fornecedor..."
                            labelBotao=""
                            ref="fornecedorpesquisa"
                            idModal="fornecedorpesquisa_cad"
                            :arredondado="true"
                            :state="valFornecedor"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="2">
                        <b-form-group label="Tipo de Arquivo" label-class="modal-label-premium">
                            <b-form-select v-model="layout.TIPO_ARQUIVO" :options="['XML', 'TXT']" class="rounded-pill bg-white border shadow-xs px-3"></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="2" v-if="layout.TIPO_ARQUIVO === 'XML'">
                        <b-form-group label="Tag do Item (XML)" label-class="modal-label-premium">
                            <b-form-input v-model="layout.TAG_ITEM" placeholder="Ex: det ou prod" class="rounded-pill bg-white border shadow-xs px-3"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="2" v-if="layout.TIPO_ARQUIVO === 'TXT'">
                        <b-form-group label="Delimitador" label-class="modal-label-premium">
                            <b-form-input v-model="layout.DELIMITADOR" placeholder="Ex: ; ou ," class="rounded-pill bg-white border shadow-xs px-3"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="2">
                        <b-form-group label="Status" label-class="modal-label-premium">
                            <b-form-select v-model="layout.ATIVO" :options="[{value: 'S', text: 'Ativo'}, {value: 'N', text: 'Inativo'}]" class="rounded-pill bg-white border shadow-xs px-3"></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Observações" label-class="modal-label-premium">
                            <b-form-input v-model="layout.OBSERVACAO" placeholder="Notas internas..." class="rounded-pill bg-white border shadow-xs px-3"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>

        <!-- Detail Section -->
        <b-col lg="12">
            <b-card class="border-0 shadow-sm rounded-lg">
                <template #header>
                    <div class="d-flex align-items-center justify-content-between w-100">
                        <div class="d-flex align-items-center">
                            <i class="fa fa-list text-primary mr-2"></i>
                            <h6 class="mb-0 font-weight-bold">Mapeamento de Itens (Colunas)</h6>
                        </div>
                        <b-button 
                            variant="soft-primary" 
                            pill size="sm" 
                            class="px-3" 
                            @click="abrirModalItem()"
                            :disabled="!layout.ID"
                            v-b-tooltip.hover
                            :title="!layout.ID ? 'Grave o cabeçalho primeiro' : ''"
                        >
                            <i class="fa fa-plus-circle mr-1"></i> ADICIONAR CAMPO
                        </b-button>
                    </div>
                </template>

                <b-table :items="layout.itens" :fields="fieldsItens" responsive hover striped show-empty empty-text="Nenhum campo mapeado.">
                    <template #cell(ORDEM)="row">
                        <span class="font-weight-bold">{{ row.item.ORDEM }}</span>
                    </template>
                    <template #cell(actions)="row">
                        <div class="d-flex justify-content-center gap-2">
                            <b-button variant="soft-primary" size="sm" class="rounded-circle mr-1" @click="editarItem(row.index)" v-b-tooltip.hover title="Editar">
                                <i class="fa fa-edit"></i>
                            </b-button>
                            <b-button variant="soft-danger" size="sm" class="rounded-circle" @click="removerItem(row.index)" v-b-tooltip.hover title="Remover">
                                <i class="fa fa-trash"></i>
                            </b-button>
                        </div>
                    </template>
                </b-table>
            </b-card>
        </b-col>
      </b-row>

      <!-- Modal Item Detail -->
      <b-modal ref="modalItem" hide-header hide-footer centered size="md" body-class="p-0 overflow-hidden">
          <div class="modal-header-premium p-3 d-flex align-items-center bg-primary">
              <div class="header-icon-wrapper mr-3" style="background: rgba(255,255,255,0.1)">
                  <i class="fa fa-plus text-white"></i>
              </div>
              <div>
                  <h5 class="mb-0 font-weight-bold text-white">{{ isEditItem ? 'Editar Campo' : 'Novo Campo' }}</h5>
                  <small class="text-white opacity-75">Configure o mapeamento deste campo</small>
              </div>
              <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs.modalItem.hide()">
                  <i class="fa fa-times fa-lg"></i>
              </b-button>
          </div>

          <div class="p-4 bg-white">
              <b-row>
                  <b-col md="12" class="mb-3">
                      <label class="modal-label-premium">Campo do Sistema (Destino)</label>
                      <b-form-select v-model="itemEdicao.CAMPO_SISTEMA" :options="optionsCampoSistema" class="rounded-pill bg-white border shadow-xs px-3" :state="!!itemEdicao.CAMPO_SISTEMA"></b-form-select>
                  </b-col>
                  <b-col md="12" class="mb-3">
                      <label class="modal-label-premium">{{ layout.TIPO_ARQUIVO === 'XML' ? 'Tag XML (Origem)' : 'Título da Coluna (Origem)' }}</label>
                      <b-form-input v-model="itemEdicao.CAMPO_ARQUIVO" placeholder="Ex: cProd, qCom, vUnCom" class="rounded-pill bg-white border shadow-xs px-3" :state="!!itemEdicao.CAMPO_ARQUIVO"></b-form-input>
                  </b-col>
                  <b-col md="6" class="mb-3">
                      <label class="modal-label-premium">Ordem/Sequência</label>
                      <b-form-input type="number" v-model.number="itemEdicao.ORDEM" class="rounded-pill bg-white border shadow-xs px-3"></b-form-input>
                  </b-col>
                  <b-col md="6" class="mb-3" v-if="layout.TIPO_ARQUIVO === 'TXT'">
                      <label class="modal-label-premium">Início (Posição)</label>
                      <b-form-input type="number" v-model.number="itemEdicao.POSICAO_INICIAL" class="rounded-pill bg-white border shadow-xs px-3"></b-form-input>
                  </b-col>
                  <b-col md="6" class="mb-3" v-if="layout.TIPO_ARQUIVO === 'TXT'">
                      <label class="modal-label-premium">Tamanho</label>
                      <b-form-input type="number" v-model.number="itemEdicao.TAMANHO" class="rounded-pill bg-white border shadow-xs px-3"></b-form-input>
                  </b-col>
                  <b-col md="6" class="mb-3">
                      <label class="modal-label-premium">Valor Padrão</label>
                      <b-form-input v-model="itemEdicao.VALOR_PADRAO" placeholder="Caso vazio..." class="rounded-pill bg-white border shadow-xs px-3"></b-form-input>
                  </b-col>
                  <b-col md="6" class="mb-3" v-if="['DATA_PRODUCAO', 'DATA_VALIDADE'].includes(itemEdicao.CAMPO_SISTEMA)">
                      <label class="modal-label-premium">Formato da Data (Máscara)</label>
                      <b-form-input v-model="itemEdicao.FORMATO_DATA" placeholder="Ex: DD/MM/YYYY" class="rounded-pill bg-white border shadow-xs px-3"></b-form-input>
                      <small class="text-muted ml-2">Ex: DD/MM/YYYY, YYYY-MM-DD, DDMMYYYY</small>
                  </b-col>
              </b-row>

              <div class="d-flex justify-content-end mt-4 pt-3 border-top gap-2">
                  <b-button variant="outline-secondary" pill class="px-4" @click="$refs.modalItem.hide()">Cancelar</b-button>
                  <b-button variant="primary" pill class="px-4 font-weight-bold" @click="confirmarItem()">
                      <i class="fa fa-check mr-1"></i> Confirmar
                  </b-button>
              </div>
          </div>
      </b-modal>

    </div>
  </div>
</template>

<script>
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import Tools from '@/tools/tools.js'

export default {
  name: 'LayoutImportacaoCadastro',
  components: {
    ClientePesquisa,
    HeaderPadrao
  },
  data() {
    return {
      isEdit: false,
      isEditItem: false,
      itemEdicaoIndex: -1,
      layout: {
        ID: null,
        DESCRICAO: '',
        FORNECEDOR_ID: null,
        TIPO_ARQUIVO: 'XML',
        TAG_ITEM: '',
        ATIVO: 'S',
        OBSERVACAO: '',
        itens: []
      },
      itemEdicao: {
        ORDEM: 1,
        CAMPO_SISTEMA: '',
        CAMPO_ARQUIVO: '',
        POSICAO_INICIAL: 0,
        TAMANHO: 0,
        VALOR_PADRAO: '',
        FORMATO_DATA: ''
      },
      fieldsItens: [
        { key: 'ORDEM', label: 'Ordem', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
        { key: 'CAMPO_SISTEMA', label: 'Campo Sistema' },
        { key: 'CAMPO_ARQUIVO', label: 'Tag/Coluna Origem' },
        { key: 'VALOR_PADRAO', label: 'Padrão' },
        { key: 'FORMATO_DATA', label: 'Formato' },
        { key: 'actions', label: 'Ações', thClass: 'text-center', tdClass: 'text-center' }
      ],
      optionsCampoSistema: [
        { value: '', text: 'Selecione um campo...' },
        { value: 'PRODUTO_ID', text: 'Código do Produto (Fornecedor)' },
        { value: 'PRODUTO_DESCRICAO', text: 'Descrição do Produto' },
        { value: 'EAN', text: 'GTIN / EAN' },
        { value: 'CODIGO_BARRAS', text: 'Código de Barras (Etiqueta)' },
        { value: 'NUMERO_SERIE', text: 'Lote / Série / Tag' },
        { value: 'DATA_PRODUCAO', text: 'Data de Produção' },
        { value: 'DATA_VALIDADE', text: 'Data de Validade' },
        { value: 'UNIDADE', text: 'Unidade Comercial' },
        { value: 'QUANTIDADE', text: 'Quantidade' },
        { value: 'PECAS', text: 'Peças / Volumes' },
        { value: 'PESO_LIQUIDO', text: 'Peso Líquido' },
        { value: 'PESO_BRUTO', text: 'Peso Bruto' },
        { value: 'VALOR_UNITARIO', text: 'Valor Unitário' },
        { value: 'VALOR_TOTAL', text: 'Valor Total Item' },
        { value: 'NCM', text: 'NCM' },
        { value: 'CST', text: 'CST / CSOSN' },
        { value: 'CFOP', text: 'CFOP' },
        { value: 'BASE_ICMS', text: 'Base ICMS' },
        { value: 'VALOR_ICMS', text: 'Valor ICMS' },
        { value: 'ALIQUOTA_ICMS', text: 'Alíquota ICMS' },
        { value: 'VALOR_IPI', text: 'Valor IPI' },
        { value: 'ALIQUOTA_IPI', text: 'Alíquota IPI' }
      ]
    }
  },
  computed: {
    isEdit() {
      return !!this.layout.ID;
    },
    valDescricao() {
      return this.layout.DESCRICAO ? this.layout.DESCRICAO.length > 0 : null;
    },
    valFornecedor() {
      return this.layout.FORNECEDOR_ID ? this.layout.FORNECEDOR_ID > 0 : null;
    },
    isDark() {
      return this.$store.state.controle.isDark
    }
  },
  methods: {
    async carregar() {
      const id = this.$route.params.id
      if (id) {
        this.isEdit = true
        this.$store.commit('controle/setAguardando', true)
        try {
          const { data } = await this.$http.get(`/api/protected/layout-importacao/getById/${id}`)
          this.layout = data
          this.layout.itens = data.ITENS || data.itens || []
        } catch (error) {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Falha ao carregar layout')
        } finally {
          this.$store.commit('controle/setAguardando', false)
        }
      }
    },
    async salvar() {
      if (!this.layout.DESCRICAO || !this.layout.FORNECEDOR_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Descrição e Fornecedor são obrigatórios')
        return
      }

      this.$store.commit('controle/setAguardando', true)
      try {
        if (this.isEdit) {
          await this.$http.put(`/api/protected/layout-importacao/edit/${this.layout.ID}`, this.layout)
        } else {
          const { data } = await this.$http.post('/api/protected/layout-importacao/post', this.layout)
          this.layout.ID = data.id
          this.isEdit = true
          // Atualiza URL sem recarregar para manter estado
          window.history.replaceState({}, '', `#/cadastros/layout-importacao/edit/${data.id}`)
        }
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Layout salvo com sucesso')
        // Se for edição, não precisa voltar obrigatoriamente se quiser continuar editando itens
        // mas o padrão do sistema costuma ser voltar. Vou deixar opcional ou apenas recarregar os dados.
        this.carregar() 
      } catch (error) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error.response?.data || 'Falha ao salvar layout')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    voltar() {
      this.$router.push('/cadastros/layout-importacao/list')
    },
    abrirModalItem() {
      this.isEditItem = false
      this.itemEdicaoIndex = -1
      this.itemEdicao = {
        ORDEM: this.layout.itens.length + 1,
        CAMPO_SISTEMA: '',
        CAMPO_ARQUIVO: '',
        POSICAO_INICIAL: 0,
        TAMANHO: 0,
        VALOR_PADRAO: '',
        FORMATO_DATA: ''
      }
      this.$refs.modalItem.show()
    },
    editarItem(index) {
      this.isEditItem = true
      this.itemEdicaoIndex = index
      this.itemEdicao = { ...this.layout.itens[index] }
      this.$refs.modalItem.show()
    },
    confirmarItem() {
      if (!this.itemEdicao.CAMPO_SISTEMA || !this.itemEdicao.CAMPO_ARQUIVO) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Campo sistema e arquivo são obrigatórios')
        return
      }

      if (this.isEditItem) {
        this.$set(this.layout.itens, this.itemEdicaoIndex, { ...this.itemEdicao })
      } else {
        this.layout.itens.push({ ...this.itemEdicao })
      }
      this.$refs.modalItem.hide()
    },
    removerItem(index) {
      this.layout.itens.splice(index, 1)
    }
  },
  mounted() {
    this.carregar()
  }
}
</script>

<style scoped>
.list-header-premium {
  border-radius: 15px;
  background: white;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
}

.header-icon-wrapper {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 20px;
}

.custom-input-premium {
  border-radius: 10px;
  border: 1px solid #e9ecef;
  padding: 0.6rem 1rem;
}

.btn-soft-primary {
  background-color: rgba(32, 168, 216, 0.1);
  color: #20a8d8;
  border: none;
}

.btn-soft-primary:hover {
  background-color: #20a8d8;
  color: white;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}

.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/layout-importacao/LayoutImportacaoCadastro.vue